import RedirectLoader from './redirectLoader';

export default RedirectLoader;
